"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var search_1 = require("utils/search");
var classNames = require("classnames");
var ColumnFilter_1 = require("components/ColumnFilter");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var SortButton = sok_ui_1.Table.SortButton;
var HeaderColumn = function (props) {
    var identifier = props.identifier, orderByOptions = props.orderByOptions, filterOptions = props.filterOptions, setOrderBy = props.setOrderBy, updateUrl = props.updateUrl, queryParams = props.queryParams, pathname = props.pathname, setColumnFilter = props.setColumnFilter;
    var order = orderByOptions.orderBy === identifier && orderByOptions.order === 'asc'
        ? 'desc'
        : 'asc';
    var enabled = true;
    var dataKey = '__' + identifier;
    var textInputValue = filterOptions && filterOptions[identifier];
    var inputType = ['publishedAt', 'updatedAt'].includes(identifier)
        ? 'day'
        : 'text';
    var handleSetColumnFilter = function (field, value) {
        var _a;
        setColumnFilter(field, value);
        var params = __assign(__assign({}, queryParams), (_a = {}, _a[field] = value, _a));
        updateUrl(pathname + (0, search_1.getQueryParams)(params));
    };
    var handleSetOrderBy = function () {
        setOrderBy(identifier, order);
        var params = __assign(__assign({}, queryParams), { order: order, orderBy: identifier });
        updateUrl(pathname + (0, search_1.getQueryParams)(params));
    };
    return (React.createElement("div", { key: identifier, "data-key": dataKey, "data-length": identifier.length, className: classNames('row__column dynamic additional-letters-list-row-column', dataKey) },
        React.createElement("div", { onClick: handleSetOrderBy }, (0, translation_1.getLocalization)("additionalLettersView/column/".concat(identifier))),
        React.createElement(SortButton, { className: "d-none d-desktop-table-cell filter", order: orderByOptions.orderBy === identifier ? order : undefined, disabled: !enabled, onChange: handleSetOrderBy }),
        React.createElement(ColumnFilter_1.ColumnFilter, { className: textInputValue ? 'active filter' : 'filter', columnIdentifier: identifier, textInputValue: textInputValue || '', inputType: inputType, setColumnFilterString: handleSetColumnFilter, clearColumnFilter: function (field) { return handleSetColumnFilter(field, undefined); } })));
};
exports.default = HeaderColumn;
